import styled from 'styled-components';
import { Box } from '@components/common';

const ModalContainer = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  max-width: 360px;
  padding: 0px 16px 0px 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px 0px rgba(0, 0, 0, 0.1);
`;

ModalContainer.defaultProps = {
  bg: 'white',
  borderRadius: 16
};

export default ModalContainer;
